var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgYoutube(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "black",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.641,
    height: 11.704,
    viewBox: "0 0 16.641 11.704",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "youtube",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill-195",
    d: "M17.3,3.468a3.6,3.6,0,0,0-.662-1.652,2.38,2.38,0,0,0-1.667-.7C12.643.943,9.15.943,9.15.943H9.142s-3.493,0-5.822.168a2.38,2.38,0,0,0-1.667.7A3.6,3.6,0,0,0,.992,3.468,25.167,25.167,0,0,0,.826,6.161V7.424a25.165,25.165,0,0,0,.166,2.693,3.6,3.6,0,0,0,.661,1.652,2.821,2.821,0,0,0,1.835.711c1.331.128,5.658.167,5.658.167s3.5-.005,5.825-.174a2.379,2.379,0,0,0,1.667-.7,3.6,3.6,0,0,0,.662-1.652,25.223,25.223,0,0,0,.166-2.693V6.161A25.224,25.224,0,0,0,17.3,3.468ZM7.428,8.953V4.278l4.5,2.346Z",
    transform: "translate(-0.826 -0.943)",
    fill: "#222631",
    fillRule: "evenodd"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.fe4a1e27c5e1f810f4f75b00b3131019.svg";
export { ForwardRef as ReactComponent };